// extracted by mini-css-extract-plugin
export default {"outlineBtnWrapper":"OutlineBtn_outlineBtnWrapper__7hSVB","outlineBtn":"OutlineBtn_outlineBtn__Tj8gg"};